(function () {
    'use strict';

    angular.module('app.alerts', [
        'app.core',
        'app.widgets'
      
    ]);
})();
